import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const mergeSiteActionTypes = {
  MERGE: type('[Site] Merge'),
  MERGE_SUCCESS: type('[Site] Merge Success'),
  MERGE_FAIL: type('[Site] Merge Fail'),
};

export class MergeSiteAction implements Action {
  readonly type = mergeSiteActionTypes.MERGE;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any ) {}
}

export class MergeSiteSuccessAction implements Action {
  readonly type = mergeSiteActionTypes.MERGE_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class MergeSiteFailAction implements Action {
  readonly type = mergeSiteActionTypes.MERGE_FAIL;
  constructor(public payload?: string) {}
}

